import StatusFlagContent from "app/features/residents/organisms/StatusFlagContent";
import {
  ResidentStatusEnum,
  StatusTitleMapping,
} from "app/services/api/types/residents/enums/ResidentStatusEnum";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { format } from "date-fns";
import { useMemo } from "react";
import { Text, View } from "react-native";
import { Avatar } from "ui/atoms/avatar";
import { StatusIndicatorType } from "ui/atoms/avatar/statusIndicator/interfaces";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import { RenderInfoItem } from "ui/molecules/common/RenderInfoItem";
import { getFullName } from "ui/utils/nameUtil";
import { ResidentProfileActions } from "../molecules/ResidentProfileActions";

type AvatarProps = {
  resident?: ResidentModel;
};

const StatusMapping: Record<ResidentStatusEnum, StatusIndicatorType> = {
  [ResidentStatusEnum.ACTIVE]: "active",
  [ResidentStatusEnum.HOSPITALISED]: "warning",
  [ResidentStatusEnum.DRAFT]: "draft",
  [ResidentStatusEnum.TERMINATED]: "danger",
};
export const ResidentProfileAvatar = ({ resident }: AvatarProps) => {
  const name = getFullName(resident);
  const nickname = resident?.known_as || null;
  const bedNumber = resident?.bed?.bed_number || "No bed specified";
  const status = resident?.status;
  const startDate = useMemo(() => {
    if (!resident?.admission_start_date) return "Not specified";

    return format(resident?.admission_start_date, "dd, MMM yyyy");
  }, [resident?.admission_start_date]);

  const endDate = useMemo(() => {
    if (!resident?.admission_end_date) return "Not specified";

    return format(resident?.admission_end_date, "dd, MMM yyyy");
  }, [resident?.admission_end_date]);

  return (
    <View className="flex flex-row gap-x-4 flex-1 items-center">
      <Avatar
        image={resident?.profile_picture?.url}
        profile={resident}
        size="lg"
      ></Avatar>
      {resident ? (
        <View className="flex flex-row flex-1 gap-x-4 items-center">
          <View className="flex flex-1 md:flex-row gap-8">
            <View className="flex-col gap-y-1">
              <View className="flex-row items-center gap-x-2 flex-wrap">
                <Text className="font-semibold text-lg overflow-hidden">
                  {name} {nickname ? `(${nickname})` : null}
                </Text>
                {status ? (
                  <StatusIndicator
                    status={StatusMapping[status]}
                    statusTitle={StatusTitleMapping[status]}
                  />
                ) : null}
              </View>

              <View className="flex flex-wrap flex-row gap-x-2 items-center">
                {RenderInfoItem(bedNumber, false)}
                {RenderInfoItem(`Check in - ${startDate}`, true)}
              </View>
              {endDate ? RenderInfoItem(`Check out - ${endDate}`, true) : null}
            </View>
            <StatusFlagContent resident={resident} />
          </View>
          <ResidentProfileActions resident={resident}></ResidentProfileActions>
        </View>
      ) : null}
    </View>
  );
};
